import React from "react";
import { useSearchParams } from "react-router-dom";
import { AcenteMealPlanning, AcenteRoomPlanning, AcenteReports } from "./AcentePages";
import AcenteAnalytics from "./AcenteAnalytics";
import { BedDouble, UtensilsCrossed, BarChart3, TrendingUp } from "lucide-react";

/**
 * Planlama & Rapor Hub — single landing page combining 4 previously-separate
 * sidebar entries: Yemek Planlama, Oda Planlama, Raporlar, Analitik.
 * Tab state persists via ?tab= so browser history and refresh keep the view.
 */
const TABS = [
  { key: "yemek",    label: "Yemek Planlama", icon: UtensilsCrossed, Component: AcenteMealPlanning },
  { key: "oda",      label: "Oda Planlama",   icon: BedDouble,       Component: AcenteRoomPlanning },
  { key: "raporlar", label: "Raporlar",       icon: BarChart3,       Component: AcenteReports },
  { key: "analitik", label: "Analitik",       icon: TrendingUp,      Component: AcenteAnalytics },
];

export default function AcentePlanningHub() {
  const [search, setSearch] = useSearchParams();
  const active = search.get("tab") || "yemek";
  const setActive = (k) => setSearch({ tab: k }, { replace: true });
  const ActiveComp = (TABS.find((t) => t.key === active) || TABS[0]).Component;

  return (
    <div className="space-y-4" data-testid="acente-planning-hub">
      <header>
        <div className="text-xs uppercase tracking-[0.3em] text-brand-orange font-semibold mb-2">Planlama & Rapor</div>
        <h1 className="font-serif text-3xl text-brand-navy">Planlama & Raporlama Merkezi</h1>
        <p className="text-sm text-slate-600 mt-1">Yemek ve oda planlamasını, raporları ve analitik grafiklerini tek yerden yönetin.</p>
      </header>

      <div className="bg-white rounded-2xl border border-brand-navy/10 p-1 shadow-sm inline-flex flex-wrap gap-1" data-testid="planning-hub-tabs">
        {TABS.map((t) => {
          const Icon = t.icon;
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setActive(t.key)}
              data-testid={`planning-hub-tab-${t.key}`}
              className={`inline-flex items-center gap-2 rounded-xl px-4 py-2 text-sm transition ${
                isActive
                  ? "bg-gradient-to-r from-brand-orange to-brand-orange-dark text-white shadow-md"
                  : "text-brand-navy hover:bg-brand-orange/5"
              }`}
            >
              <Icon size={14} /> {t.label}
            </button>
          );
        })}
      </div>

      {/* Only mount the active tab to avoid ResponsiveContainer w/h -1 warnings
          from Recharts when it renders inside a hidden container. */}
      <div key={active}>
        <ActiveComp />
      </div>
    </div>
  );
}
